<template>
	<div id="projectModal" style="display: block" class="modal" role="dialog">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="titleModal">Select Project</h4>
					<b-button class="btnSize addBtn" @click="addProject()"
						>New Project</b-button
					>
				</div>
				<div class="modal-body">
					<div class="search-input-area">
						<font-awesome-icon :icon="['fas', 'search']" class="search-icon" />
						<input
							type="text"
							placeholder="Search Project"
							class="form-control block search-input"
							v-on:input="searchProject($event.target.value)"
						/>
					</div>

					<div
						class="cellContainer"
						v-for="(projectItem, projectKey) in projects"
						:key="projectKey"
						tabindex="1"
						:class="selectedProject == projectItem ? 'selected' : ''"
						@click="$emit('projectselectDone', projectItem)"
					>
						<div class="details">
							<div class="title project">{{ projectItem.Name }}</div>
							<font-awesome-icon
								:icon="['fas', 'check-circle']"
								class="selectedIcon"
							/>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<b-button class="btnSize cancelBtn" @click="$emit('close')"
						>Cancel</b-button
					>
					<!-- <b-button class="btnSize sendBtn" :class="selectedProject ? 'active' : ''" @click="$emit('projectselectDone', selectedProject)">Done</b-button> -->
				</div>
			</div>
		</div>
		<CreateProject
			v-if="isAddProject"
			id="createProjectModal"
			@close="isAddProject = false"
		></CreateProject>
	</div>
</template>

<script>
import { mapState } from "vuex";
import CreateProject from "./expense/CreateProject";
export default {
	name: "Project",
	props: ["selectedProjectName"],
	data() {
		return {
			isAddProject: false,
			selectedProject: null,
			original_projectArr: []
		};
	},
	components: {
		CreateProject
	},
	computed: {
		...mapState(["attributes"]),
		projects: {
			get: function() {
				if (this.$store) {
					var self = this;
					return _.sortBy(this.$store.state.attributes.project, [
						function(data) {
							if (
								self.selectedProjectName &&
								data.Name == self.selectedProjectName
							) {
								self.selectedProject = data;
							}
							return data.Name;
						}
					]);
				}
				return [];
			},
			set: function(value) {
				this.$store.state.attributes.project = value;
			}
		}
	},
	mounted() {
		this.original_projectArr = this.projects;
		if (!this.$store.state.attributes.project)
			this.$store.dispatch("loadAttribute");
	},
	methods: {
		addProject() {
			this.isAddProject = true;
		},
		searchProject(keyword) {
			const self = this;
			if (keyword) {
				clearInterval(this.pendingCheck);
				if (this.projects.length < 1) {
					this.projects = this.original_projectArr;
				}
				let filteredData = _.filter(this.projects, function(result) {
					if (_.includes(result.Name.toLowerCase(), keyword.toLowerCase())) {
						return result;
					}
				});
				this.projects = _.sortBy(filteredData, [
					function(data) {
						return data.Name;
					}
				]);
			} else {
				this.projects = this.original_projectArr;
			}
		}
	}
};
</script>
